import { Component, Inject, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';

export interface DialogData {
  dialogTitle: string;
  dialogText: string;
  technicalDescription?: string; // For AI technical description
  confirmBtntext?: string;
  declineBtnText?: string;
  customCssClass?: string;
  singleButton?: boolean; // New flag to show only the confirm button
  secondButtonText?: string; // Optional second action button (e.g. Reject)
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements AfterViewInit {
  public isMobile: boolean = environment.type === 'mobile';
  public showTechnicalDescription: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.data.confirmBtntext = this.data.confirmBtntext || POPUP_TEXT.CONFIRM_DEFAULTS.confirmBtntext;
    this.data.declineBtnText = this.data.declineBtnText || POPUP_TEXT.CONFIRM_DEFAULTS.declineBtnText;
    this.data.customCssClass = this.data.customCssClass || '';
    this.data.singleButton = this.data.singleButton || false;

    // Append 'long-tilte' if dialogTitle length > 6
    if (this.data.confirmBtntext && this.data.confirmBtntext.length > 6) {
      this.data.customCssClass += (this.data.customCssClass ? ' ' : '') + 'long-tilte';
    }

    // Add single-button class when only showing one button
    if (this.data.singleButton) {
      this.data.customCssClass += (this.data.customCssClass ? ' ' : '') + 'single-button';
    }
  }

  toggleTechnicalDescription(): void {
    this.showTechnicalDescription = !this.showTechnicalDescription;
  }

  getCurrentDescription(): string {
    if (this.showTechnicalDescription && this.data.technicalDescription) {
      return this.data.technicalDescription;
    }
    return this.data.dialogText;
  }

  ngAfterViewInit() {
    const overlayPane = this.elementRef.nativeElement.closest('.cdk-overlay-pane');
    if (overlayPane && this.isMobile) {
      this.renderer.addClass(overlayPane, 'is-mobile');
    } else {
      this.renderer.addClass(overlayPane, 'is-desktop');
    }
  }
}
